import { CSSProperties } from 'react';

export const dropdownStyles: CSSProperties = {
  borderRadius: 2,
  padding: 0,
  boxShadow:
    '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)',
};

export const dropdownSpaceStyles: CSSProperties = {
  width: '100%',
  height: 64,
  justifyContent: 'center',
  backgroundColor: '#F0F0F0',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
};

export const dropdownSpaceButtonStyles: CSSProperties = {
  background: '#FFFFFF',
  border: '1px solid #D9D9D9',
  boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.016)',
  borderRadius: 2,
};
